import React, { useState } from 'react';

import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { yupResolver } from '@hookform/resolvers/yup';
import WarningIcon from 'assets/LeadInfo/warningGrey.svg';
import Input from 'common-ui/input';
import Modal from 'common-ui/modal';
import TextArea from 'common-ui/textArea';
import { createLeadNote } from 'features/newsales/newsalesActions';
import * as Yup from 'yup';

import {
  ButtonRow,
  CancelButton,
  Label,
  NoteIcon,
  NoteSection,
  Section,
  SubmitButton,
} from './LeadInfoModal.styles';

const noteSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string().max(200, 'Max length exceeded').nullable(),
});

const LeadInfoModal = ({ isOpen, onClose, leadId, onSuccess }) => {
  const dispatch = useDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(noteSchema),
    defaultValues: { title: '', description: '' },
    shouldFocusError: false,
  });

  const resetForm = () => {
    reset();
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      await dispatch(
        createLeadNote({
          leadId,
          noteData: {
            title: data.title.trim(),
            description: data.description.trim(),
          },
        })
      ).unwrap();

      resetForm();
      onClose();
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Failed to create note:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={'Add Note'}
      footer={false}
      width="450px"
    >
      <>
        <Section className="title-margin">
          <Controller
            name="title"
            control={control}
            render={({ field }) => (
              <Input
                label="Title"
                required
                placeholder="Add any important information about this lead..."
                value={field.value}
                onChange={field.onChange}
                error={errors.title?.message}
              />
            )}
          />
        </Section>
        <NoteSection>
          <Label>
            Description
            <NoteIcon src={WarningIcon} />
          </Label>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextArea
                placeholder="Add any important information about this lead..."
                value={field.value}
                onChange={field.onChange}
                rows={4}
                resizeVertical={false}
                resizeHorizontal={false}
                maxLength={200}
                error={errors.description?.message}
              />
            )}
          />
        </NoteSection>
      </>
      <ButtonRow>
        <CancelButton onClick={handleClose} disabled={isSubmitting}>
          Cancel
        </CancelButton>
        <SubmitButton onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </SubmitButton>
      </ButtonRow>
    </Modal>
  );
};

export default LeadInfoModal;
